export default "__VITE_PUBLIC_ASSET__8a0a4fc5__"